import { gql } from "@apollo/client/core";

export const GET_STOCK_SITE_LOCATIONS = gql`
  query GetStockSites($distributorId: ID!, $stockSiteInput: StockSiteInput) {
    getStockSites(distributorId: $distributorId, stockSiteInput: $stockSiteInput) {
      nodes {
        address
        city
        region
        postalCode
        name
        storeWebsite
        storePhone
        storeEmail
      }
    }
  }
`;
